module.exports = __webpack_public_path__ + "img/buddy_eyes-01.197379f4.svg";